import React from "react";
import { useSelector } from "react-redux";

const ChatItem = ({ flag, desc, scrollRef }) => {
  const themeMode = useSelector((state) => state.themeMode);

  return (
    <div
      className={`chat-main-section ${flag ? "flex-end" : "flex-start"}`}
      ref={scrollRef}
    >
      {flag ? (
        <div
          className="chat-client-section"
          style={{
            backgroundColor: themeMode.themeMode
              ? "#323232d9"
              : "rgb(237 221 221 / 85%)",
          }}
        >
          <div className="chat-desc">{desc}</div>
        </div>
      ) : (
        <div className="chat-assistant-section">
          <div className="chat-desc">{desc}</div>
        </div>
      )}
    </div>
  );
};

export default ChatItem;
